<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <RentsReportFilter v-model="filter" @filter="loadRents" />
    <RentsPerUserReportList :rents="rents" @refresh="loadRents" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import withAsyncAction from '@/mixins/withAsyncAction'
import services from '@/services'
import RentsReportFilter from './RentsReportFilter'
import RentsPerUserReportList from './RentsPerUserReportList'
import { formatDate } from '@/helpers/date'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'

export default {
  name: 'RentsPerUserReport',
  components: {
    RentsReportFilter,
    RentsPerUserReportList,
    StoreSwitcher
  },
  mixins: [
    withAsyncAction({
      key: 'rents',
      initialState: [],
      fetcher: {
        methodName: 'fetchRentsPerUserReport',
        handler: services.reports.fetchRentsPerUserReport
      }
    })
  ],
  data() {
    return {
      filter: {
        fromDate: formatDate(new Date()),
        toDate: formatDate(new Date())
      }
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin'])
  },
  created() {
    this.loadRents()
  },
  methods: {
    loadRents() {
      const storeId = this.currentStoreId
      const { fromDate, toDate } = this.filter
      this.fetchRentsPerUserReport({ storeId, fromDate, toDate })
    }
  }
}
</script>
